module.exports = __webpack_public_path__ + "media/images/admin2/AdminDashboardIndex__calendar-e87babdf0594d11693f4b2d7377d8ecd.svg";